import { createStore } from 'vuex';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

const store = createStore({
  state: {
    vendeurId: localStorage.getItem('vendeurId') || null,
    clientId: localStorage.getItem('clientId') || null,
    superAdminId: localStorage.getItem('superAdminId') || null,
    livreurId: localStorage.getItem('livreurId') || null,
    livreurToken: null,
    vendeurToken: null,
    clientToken: null,
    adminToken: localStorage.getItem('adminToken') || null,
    superAdminToken: localStorage.getItem('superAdminToken') || null,
    client: JSON.parse(localStorage.getItem('client')) || null,
    list: [],
    selectedCategory: null,
    achats: [],
    totalSum: 0,
    selectedProduct: null,
    hideElement: false,
    montant: null,
    loading: false,
    stockIssues: [] // Add stockIssues to state
  },
  mutations: {
    setAdminId(state, id) {
      state.adminId = id;
      localStorage.setItem('adminId', id);
    },
    setSuperAdminId(state, id) {
      state.superAdminId = id;
      localStorage.setItem('superAdminId', id);
    },
    setHideElement(state, value) {
      state.hideElement = value;
    },
    setSelectedProduct(state, product) {
      state.selectedProduct = product;
    },
    logout(state) {
      state.client = null;
    },
    updateTotalSum(state, totalSum) {
      state.totalSum = totalSum;
    },
    addToCart(state, product) {
      state.cart.items.push(product);
    },
    removeFromCart(state, product) {
      const index = state.achats.findIndex(achat => achat.produit.id === product.id);
      if (index !== -1) {
        state.achats.splice(index, 1);
      }
    },
    setAchats(state, achats) {
      state.achats = achats;
    },
    setPreviousRoute(state, route) {
      state.previousRoute = route;
    },
    setLivreurToken(state, token) {
      state.livreurToken = token;
      localStorage.setItem('token', token);
    },
    setLivreurId(state, id) {
      localStorage.setItem('livreurId', id);
      state.livreurId = id;
    },
    setClientId(state, id) {
      localStorage.setItem('clientId', id);
      state.clientId = id;
    },
    setVendeurToken(state, token) {
      localStorage.setItem('vendeurToken', token);
      state.vendeurToken = token;
    },
    setVendeurId(state, id) {
      localStorage.setItem('vendeurId', id);
      state.vendeurId = id;
    },
    setClientToken(state, token) {
      localStorage.setItem('clientToken', token);
      state.clientToken = token;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    clearAuthData(state) {
      state.vendeurId = null;
      state.clientId = null;
      state.livreurId = null;
      state.adminId = null;
      state.superAdminId = null;
      state.vendeurToken = null;
      state.clientToken = null;
      state.livreurToken = null;
      state.adminToken = null;
      state.superAdminToken = null;
      localStorage.removeItem('vendeurId');
      localStorage.removeItem('clientId');
      localStorage.removeItem('livreurId');
      localStorage.removeItem('adminId');
      localStorage.removeItem('superAdminId');
      localStorage.removeItem('vendeurToken');
      localStorage.removeItem('clientToken');
      localStorage.removeItem('livreurToken');
      localStorage.removeItem('adminToken');
      localStorage.removeItem('superAdminToken');
    },
    setClient(state, client) {
      if (client) {
        state.client = client;
        localStorage.setItem('client', JSON.stringify(client));
      } else {
        console.error('Received null client data');
        state.client = null;
        localStorage.removeItem('client');
      }
    },
    clearClientData(state) {
      state.client = null;
      localStorage.removeItem('client');
    },
    setList(state, list) {
      state.list = list;
    },
    setSelectedCategory(state, category) {
      state.selectedCategory = category;
    },
    setAdminToken(state, token) {
      state.adminToken = token;
      localStorage.setItem('adminToken', token);
    },
    setSuperAdminToken(state, token) {
      state.superAdminToken = token;
      localStorage.setItem('superAdminToken', token);
    },
    setMontant(state, montant) {
      state.montant = Number(montant) || 0;
      localStorage.setItem('montant', state.montant);
      state.loading = false;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    // Add stock issues mutation
    setStockIssues(state, issues) {
      state.stockIssues = issues;
    }

  },
  actions: {

    setClientToken({ commit }, token) {
      commit('setClientToken', token);
      // Optional but highly recommended: set global header immediately
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    async loginAdmin({ commit }, { email, password }) {
      try {
        const response = await axios.post('https://scap.ma/api/login', { email, password });
        const { token, adminId, adminName } = response.data;
        commit('setAdminToken', token);
        commit('setAdminId', adminId);
        localStorage.setItem('adminName', adminName);
        return '/admin/dashboard';
      } catch (error) {
        console.error('Admin login failed:', error.response?.data || error.message);
        throw error;
      }
    },
    async loginSuperAdmin({ commit }, { email, password }) {
      try {
        const response = await axios.post('https://scap.ma/api/login/super', { email, password });
        const { token, superAdminId, superAdminName } = response.data;
        commit('setSuperAdminToken', token);
        commit('setSuperAdminId', superAdminId);
        localStorage.setItem('superAdminName', superAdminName);
        return '/super-admin/dashboard';
      } catch (error) {
        console.error('Super admin login failed:', error.response?.data || error.message);
        throw error;
      }
    },
    fetchAchats({ commit }, clientId) {
      return axios.get(`https://scap.ma/api/client/${clientId}/achats`)
        .then(response => {
          commit('setAchats', response.data);
          return response;
        })
        .catch(error => {
          console.error('Error fetching achats:', error);
        });
    },
    async fetchMontant({ commit }, clientCity) {
      try {
        commit('setLoading', true);
        const response = await axios.get(`https://scap.ma/api/livraison/by-ville?ville=${clientCity}`);
        commit('setMontant', response.data.montant);
      } catch (error) {
        console.error('Error fetching delivery fee:', error);
        commit('setMontant', 0);
      }
    },
    setVendeurId({ commit }, id) {
      commit('setVendeurId', id);
    },
    setVendeurToken({ commit }, token) {
      commit('setVendeurToken', token);
    },
    setLivreurId({ commit }, id) {
      commit('setLivreurId', id);
    },
    setClientId({ commit }, id) {
      commit('setClientId', id);
    },
    setLivreurToken({ commit }, token) {
      commit('setLivreurToken', token);
    },
    async login({ dispatch }, { email, password }) {
      try {
        const response = await axios.post('https://scap.ma/api/loginV', { email, password });
        const { token, vendeurId } = response.data;
        dispatch('setVendeurId', vendeurId);
        dispatch('setVendeurToken', token.id);
        return '/vendor/dashboard';
      } catch (error) {
        console.error('Login failed:', error.response ? error.response.data : error.message);
        throw error;
      }
    },
    async loginlivreure({ dispatch }, { email, password }) {
      try {
        const response = await axios.post('https://scap.ma/api/livreur/login', { email, password });
        const { token, livreur } = response.data;
        const livreurId = livreur.id;
        await dispatch('setLivreurId', livreurId);
        await dispatch('setLivreurToken', token);
        return '/livreur/dashboard';
      } catch (error) {
        console.error('Login failed:', error.response ? error.response.data : error.message);
        throw error;
      }
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
    },
    logout({ commit }) {
      commit('clearAuthData');
      commit('clearClientData');
    },
    async loginClient({ dispatch, commit }, { email, password, redirect }) {
      try {
        const response = await axios.post('https://scap.ma/api/loginC', { email, password });
        const { token, clientId } = response.data;
    
        // Use the new action + set ID
        await dispatch('setClientToken', token);
        commit('setClientId', clientId);  // or dispatch('setClientId', clientId) if you add action for it
    
        // Extra safety: set header here too
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
        await dispatch('fetchClient');
        await dispatch('fetchAchats', clientId);
    
        return redirect || '/';
      } catch (error) {
        console.error('Login failed:', error.response?.data || error.message);
        throw error;
      }
    },
    async fetchClient({ commit, state }) {
      try {
        if (!state.clientId) return;
        const response = await axios.get(`https://scap.ma/api/clients/${state.clientId}`, {
          headers: {
            Authorization: `Bearer ${state.clientToken}`
          }
        });
        commit('setClient', response.data);
      } catch (error) {
        console.error('Error fetching client data:', error);
        commit('clearClientData');
      }
    },

    // Stock validation actions
    async checkProductStock(_, productId) {
      try {
        const response = await axios.get(`https://scap.ma/api/produits/edit/${productId}`);
        return response.data;
      } catch (error) {
        console.error('Error checking product stock:', error);
        throw error;
      }
    },

    /**
     * Pre-checkout cart validation.
     *
     * Old behaviour: ran one GET /api/produits/edit/:id per cart line in
     * series — checkout latency was O(n) on cart size, often the slowest
     * step before payment. We now batch all lines into a single
     * POST /api/produits/stock-check call (one round-trip, indexed query).
     *
     * On legacy backends without the new endpoint we fall back to the old
     * sequential path so the existing UX keeps working during a partial
     * deploy. Same `stockIssues` shape is committed in both cases so all
     * call sites (PanierPage, Buy.vue) stay unchanged.
     */
    async validateCartStock({ commit, state }) {
      const achats = state.achats || [];
      if (!achats.length) {
        commit('setStockIssues', []);
        return [];
      }

      try {
        const items = achats.map((a) => ({
          produit_id: a.produit?.id,
          quantite: Number(a.quantite || 0),
        })).filter((x) => x.produit_id && x.quantite > 0);

        const r = await axios.post('https://scap.ma/api/produits/stock-check', { items });
        const stockIssues = (r.data?.stock_errors || []).map((err) => ({
          product_id: err.product_id,
          product_name: err.product_name,
          requested: err.requested,
          available: err.available,
          reason: err.reason,
        }));
        commit('setStockIssues', stockIssues);
        return stockIssues;
      } catch (error) {
        // 404 means the endpoint isn't deployed yet — fall back gracefully.
        if (error.response?.status === 404) {
          return await this.dispatch('validateCartStockLegacy');
        }
        // For any other error, fail closed: surface a generic error per line
        // so the user sees actionable feedback instead of a silent pass.
        const stockIssues = achats.map((a) => ({
          product_id: a.produit?.id,
          product_name: a.produit?.nom,
          error: error.response?.data?.error || error.message || 'Erreur de vérification du stock',
        }));
        commit('setStockIssues', stockIssues);
        return stockIssues;
      }
    },

    async validateCartStockLegacy({ commit, state }) {
      const achats = state.achats || [];
      const stockIssues = [];

      for (const achat of achats) {
        try {
          const product = await axios.get(`https://scap.ma/api/produits/edit/${achat.produit.id}`);
          const productData = product.data;
          const totalQuantityOrdered = productData.orderItems?.reduce((sum, item) => sum + item.quantite, 0) || 0;
          const availableStock = productData.quantite - totalQuantityOrdered;
          if (availableStock < achat.quantite) {
            stockIssues.push({
              product: productData,
              product_id: productData.id,
              product_name: productData.nom,
              requested: achat.quantite,
              available: Math.max(0, availableStock),
            });
          }
        } catch (e) {
          stockIssues.push({
            product_id: achat.produit.id,
            product_name: achat.produit.nom,
            error: 'Erreur de vérification du stock',
          });
        }
      }

      commit('setStockIssues', stockIssues);
      return stockIssues;
    },

    async preValidateOrder({ dispatch }) {
      const stockIssues = await dispatch('validateCartStock');
      
      if (stockIssues.length > 0) {
        return {
          valid: false,
          issues: stockIssues,
          message: 'Certains produits ne sont plus disponibles en quantité suffisante'
        };
      }
      
      return {
        valid: true,
        issues: [],
        message: 'Stock validé avec succès'
      };
    },

    async fetchAchatsWithStock({ commit, dispatch }, clientId) {
      try {
        const response = await axios.get(`https://scap.ma/api/client/${clientId}/achats`);
        commit('setAchats', response.data);
        
        await dispatch('validateCartStock');
        
        return response;
      } catch (error) {
        console.error('Error fetching achats with stock validation:', error);
        throw error;
      }
    },

    async removeOutOfStockItems({ commit, dispatch, state }) {
      const stockIssues = await dispatch('validateCartStock');
      const outOfStockProductIds = stockIssues.map(issue => issue.product_id);
      
      const validAchats = state.achats.filter(achat => 
        !outOfStockProductIds.includes(achat.produit.id)
      );
      
      if (validAchats.length !== state.achats.length) {
        commit('setAchats', validAchats);
        console.log('Removed out-of-stock items from cart');
      }
      
      return validAchats;
    }
  },
  getters: {
    isAuthenticated: (state) => {
      return state.vendeurToken || state.clientToken || state.livreurToken || state.adminToken || state.superAdminToken;
    },
    vendeurId: state => state.vendeurId,
    clientId: state => state.clientId,
    achatCount: (state) => {
      return state.achats.length;
    },
    productCities: state => state.achats.map(achat => achat.produit.ville),
    clientAddress: state => state.client ? state.client.adresse : null,
    clientName: state => state.client ? state.client.name : null,
    clientCity: state => state.client ? state.client.ville : null,
    client: (state) => state.client,

    // Stock-related getters
    getStockIssues: (state) => state.stockIssues || [],
    
    hasStockIssues: (state) => (state.stockIssues && state.stockIssues.length > 0),
    
    getAchats: (state) => state.achats,
    
    getValidAchats: (state) => {
      const stockIssues = state.stockIssues || [];
      const outOfStockProductIds = stockIssues.map(issue => issue.product_id);
      
      return state.achats.filter(achat => 
        !outOfStockProductIds.includes(achat.produit.id)
      );
    },
    
    getOutOfStockAchats: (state) => {
      const stockIssues = state.stockIssues || [];
      const outOfStockProductIds = stockIssues.map(issue => issue.product_id);
      
      return state.achats.filter(achat => 
        outOfStockProductIds.includes(achat.produit.id)
      );
    },
    
    getValidTotalSum: (state, getters) => {
      const validAchats = getters.getValidAchats;
      return validAchats.reduce((total, achat) => total + achat.montant, 0);
    }
  },
  plugins: [
    createPersistedState({
      paths: [
        'vendeurId',
        'clientId',
        'superAdminId',
        'livreurId',
        'adminId',
        'vendeurToken',
        'clientToken',
        'livreurToken',
        'adminToken',
        'superAdminToken',
        'token',
        'client',
        'montant',
        'achats',
        'stockIssues',
      ],
    }),
  ],
});

export default store;